// extracted by mini-css-extract-plugin
export default {"clickable_cell":"DataTable_clickable_cell__ET9vV"};